import { jsxs as o, jsx as a } from "react/jsx-runtime";
import { R as x, b as I, P as b, O as L, C as j, T as B, D as P, a as d } from "../../../index-PFltbIyu.js";
import { c as _ } from "../../../clsx-OuTLNxxd.js";
import { useState as R } from "react";
import { B as g } from "../../../button.types-BqgkEc5r.js";
import "../button/iconButton/iconButton.js";
import { C as T } from "../../../callout-CHtty_37.js";
import { I as z } from "../../../icon-B72I4fRl.js";
import "../icon/iconsList.js";
const E = "_icon_a406m_79", e = {
  "alert-dialog-overlay": "_alert-dialog-overlay_a406m_29",
  "dialog-overlay-show": "_dialog-overlay-show_a406m_1",
  "alert-dialog": "_alert-dialog_a406m_29",
  "dialog-content-show": "_dialog-content-show_a406m_1",
  "alert-dialog-title": "_alert-dialog-title_a406m_66",
  icon: E,
  "icon-success": "_icon-success_a406m_82",
  "icon-error": "_icon-error_a406m_85",
  "icon-warning": "_icon-warning_a406m_88",
  "icon-info": "_icon-info_a406m_91",
  "alert-dialog-description": "_alert-dialog-description_a406m_95",
  "alert-dialog-content": "_alert-dialog-content_a406m_102",
  "alert-dialog-actions": "_alert-dialog-actions_a406m_112",
  "dialog-content-slide-up": "_dialog-content-slide-up_a406m_1"
}, K = {
  success: "verification-check-regular",
  error: "error-regular",
  warning: "warning-regular",
  info: "information-circle-regular"
};
function U({
  children: m,
  dialogTriggerNode: h,
  title: u,
  confirmActionText: p,
  dismissActionText: l,
  onDismissAction: n,
  onConfirmAction: t,
  confirmActionColor: f = "primary",
  iconStatus: r,
  calloutProps: c,
  isOpen: v,
  confirmActionIsLoading: y,
  setIsOpen: C,
  defaultOpen: w
}) {
  const N = _(e["alert-dialog"]), [D, s] = R(!1), O = y || D, k = async (i) => {
    if (t)
      try {
        s(!0), await t(i);
      } finally {
        s(!1);
      }
  };
  return /* @__PURE__ */ o(x, { defaultOpen: w, open: v, onOpenChange: C, children: [
    /* @__PURE__ */ a(I, { asChild: !0, children: h }),
    /* @__PURE__ */ o(b, { children: [
      /* @__PURE__ */ a(L, { className: e["alert-dialog-overlay"] }),
      /* @__PURE__ */ o(
        j,
        {
          "aria-describedby": void 0,
          className: N,
          onInteractOutside: (i) => i.preventDefault(),
          onPointerDownOutside: (i) => i.preventDefault(),
          onEscapeKeyDown: (i) => i.preventDefault(),
          children: [
            /* @__PURE__ */ o(B, { className: e["alert-dialog-title"], children: [
              r && /* @__PURE__ */ a("div", { className: _(e.icon, e[`icon-${r}`]), children: /* @__PURE__ */ a(z, { color: "inherit", name: K[r], size: "7xl" }) }),
              u
            ] }),
            /* @__PURE__ */ a(P, { asChild: !0, children: /* @__PURE__ */ o("div", { className: e["alert-dialog-description"], children: [
              /* @__PURE__ */ a("div", { className: e["alert-dialog-content"], children: m }),
              c?.children && /* @__PURE__ */ a("div", { className: e["callout-container"], children: /* @__PURE__ */ a(T, { ...c }) })
            ] }) }),
            /* @__PURE__ */ o("div", { className: e["alert-dialog-actions"], children: [
              l && n && /* @__PURE__ */ a(d, { asChild: !0, children: /* @__PURE__ */ a(g, { color: "tertiary", onClick: n, children: l }) }),
              /* @__PURE__ */ a(d, { asChild: !0, children: /* @__PURE__ */ a(g, { isLoading: O, color: f, onClick: k, children: p }) })
            ] })
          ]
        }
      )
    ] })
  ] });
}
export {
  U as AlertDialog
};
